module.exports = __webpack_public_path__ + "static/qh_16.b01480b7.jpg";